const hideElement = (elem) => {
  if (elem) {
    elem.style.display = 'none';
  }
};

export default hideElement;
